import { render, staticRenderFns } from "./ExportCoupon.vue?vue&type=template&id=2a5cd668"
import script from "./ExportCoupon.vue?vue&type=script&lang=ts"
export * from "./ExportCoupon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports